export const CHEVRON_FONT_SIZE = 40;
